// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"main":"5138ddb1fae1ff1861c5","app_scenes_NotFound_index_js":"060700f6c17cb897c5dc"}[chunkId] + ".css";
};